import { PageHeader } from '@ant-design/pro-layout';
import { Layout } from 'antd';
import React, { useMemo, useState } from 'react';
import { ErrorPopup } from '../../components/errorPopup/ErrorPopup';
import { Loadable } from '../../components/loadable/Loadable';
import { Section } from '../../components/section/Section';
import { useFeatureFlag } from '../../featureFlags';
import { flags } from '../../featureFlags/flags';
import { Routes } from '../../routes';
import { buildPageHeaderBreadcrumb } from '../../updated/utils'; 
import CallbacksConfig from './CallbacksConfig.js';
import './styles.less';

const useLoading = ( keys = [] ) => {

    const [ loading, setLoading ] = useState( Object.fromEntries( keys.map( k => [ k, true ] ) ) );

    return useMemo( () => ( {
        loading: Object.values( loading ).some( x => !!x ),
        setLoading: ( key, value ) => setLoading( { ...loading, [ key ]: value } ),
    } ), [ loading ] );
};

export default function Settings() {

    const { loading, setLoading } = useLoading( [ 'callbacks' ] );
    const [ error, setError ] = useState( [] );

    const callbackEnabled = useFeatureFlag( { name: flags.SETTINGS_CALLBACKS } );

    return (
        <Layout className='settings-page'>
            <PageHeader
                breadcrumb={ buildPageHeaderBreadcrumb( [
                    { breadcrumbName: 'Course Studio', path: Routes.Home.buildPath() },
                    { breadcrumbName: 'Settings' }
                ] ) } 
                title='Course Studio Settings'
            />
            <ErrorPopup errors={ error } />

            <Loadable loading={ loading } >

                <Section className='config-section'>
                    <CallbacksConfig disabled={ !callbackEnabled } setLoading={ ( val ) => setLoading( 'callbacks', val )  } setError={ ( e ) => setError( [ ...error, ...e ] ) } />
                </Section>

            </Loadable>            
        </Layout>
    );
}

